import React from 'react'
import Slider from "react-slick/lib";
import {withRouter} from "react-router";
import { Link } from 'react-router-dom';
import {Accordion,Card} from 'react-bootstrap';
import * as CONFIG from './_config';
import {Helmet} from "react-helmet";
import Slide from './slide'

let slides = [
    {
      background: "/assets/web/images/DSC_546.jpg",
     },
    {
      background: "/assets/web/images/DSC_556.jpg",
     },
    {
      background: "/assets/web/images/DSC_1520.jpg",
      
    },
    {
        background: "/assets/web/images/DSC_1555.jpg",
        
      },
      {
        background: "/assets/web/images/DSC_3311.jpg",
        
      },
      {
        background: "/assets/web/images/DSC_3322.jpg",
        
      }

  ];
class About extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            about:{},
            activeSlide:0,
        }
    };

    componentDidMount() {
        this.About(); 
    }

    prevSlide() {
        let slide = this.state.activeSlide - 1 < 0
          ? slides.length - 1
          : this.state.activeSlide - 1;
        this.setState({
          activeSlide: slide
        });
      }
      nextSlide() {
        let slide = this.state.activeSlide + 1 < slides.length
          ? this.state.activeSlide + 1
          : 0;
        this.setState({
          activeSlide: slide
        });
      }

      
    
    
    componentDidUpdate(prevProps, prevState) {
        if(this.props.location.pathname !== prevProps.location.pathname) {
            this.About();
        }
    }

    About = ()=>{
        
        var about_menu = CONFIG.DATA.MENU.find(x => x.menu_url === '/about');
        const about_submenu = about_menu.submenu.find(x => x.submenu_url === this.props.match.url);

        this.setState({
            about_menu: about_menu
            , about_submenu: about_submenu
        })

    }


    render() {
        
        const about_menu = this.state.about_menu;
        const about_submenu = this.state.about_submenu;

        // console.log(about_menu, about_submenu);


        if(!about_menu && !about_submenu) 
          return (
            <div style={{textAlign:'left', minHeight:'600px'}}>
              <div className="content">
                <div className="overlay">
                  <div className="overlay-content">
                    <img style={{maxWidth:'none'}} src="/assets/images/loading.gif" alt="Loading..." />
                  </div>
                </div>    
              </div>
            </div>
          );

        var Name = this.props.match.params.page || (about_submenu ? about_submenu.submenu_name : about_menu.menu_name);
        Name = Name.replace(/-/g,' ');


        function SampleNextArrow(props) {
            const { className, style, onClick } = props;
            return (
                <div
                    className={className}
                    style={{ ...style, display: "block"}}
                    onClick={onClick}
                />
            );
        }

        function SamplePrevArrow(props) {
            const { className, style, onClick } = props;
            return (
                <div
                    className={className}
                    style={{ ...style, display: "block"}}
                    onClick={onClick}
                />
            );
        }

        const testimonial_slider_options = {
            infinite: true,
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
            center: false,
            loop: true,
            stagePadding: 10,
            margin: 30,
            autoplay: false,
            smartSpeed: 500,
            autoplaySpeed: CONFIG.DATA.SLIDER_SPEED_MS,
            nav: false,
            dots: false,
            lazyLoad: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        };

        const customer_brand_slider_options = {
            infinite: true,
            speed: 800,
            slidesToShow: 6,
            slidesToScroll: 3,
            center: true,
            loop: true,
            stagePadding: 10,
            margin: 30,
            autoplay: true,
            smartSpeed: 500,
            autoplaySpeed: CONFIG.DATA.SLIDER_SPEED_MS,
            nav: false,
            dots: false,
            lazyLoad: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
        };

    return (
        <div className="main-container full-width pt-2 mt-2">

            <div className="title-breadcrumb">
                <div className="container">
                    <div className="title-breadcrumb-inner">
                        <header className="entry-header">
                            <h1 className="entry-title">{Name}</h1>
                        </header>
                        <div className="breadcrumbs"><Link to="/">Home</Link><span className="separator">/</span><span>{Name}</span></div>
                    </div>
                </div>
            </div>

            <div className='container'>
                <div className="row abou_us_page about-page" style={{marginLeft:'0px', marginRight:'0px'}} >

                    <div className="vc_col-xs-12">
                        <div className="page-content default-page">
                            <article className="post-8436 page type-page status-publish hentry">
                                <div className="entry-content">
                                    <div className="vc_row wpb_row vc_row-fluid">
                                        <div className="row-container" style={{/* marginLeft:'25%',*/ marginTop:'25px'}} >
                                        {
                                            about_submenu
                                            ?
                                            <div className="wpb_column vc_column_container vc_col-sm-10">
                                              <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                     <div className="row">
                                                         <div dangerouslySetInnerHTML={{__html: about_submenu.submenu_html_text }} ></div>
                                                     </div>
                                                     <div className="row">
                                                         <div className="col-md-12 text-left aboutus_page" style={{paddingLeft:'0px', paddingRight:'0px'}} >
                                                            {
                                                            about_submenu.submenu_list ?
                                                                <Accordion defaultActiveKey={0}>
                                                                     {about_submenu.submenu_list.map((val, key) => (
                                                                         <Card key={key}>
                                                                             <Accordion.Toggle as={Card.Header} eventKey={key} >
                                                                                 {val.name}
                                                                             </Accordion.Toggle>
                                                                             <Accordion.Collapse eventKey={key}>
                                                                                 <Card.Body>
                                                                                     <div className='container'>
                                                                                     <div className="row">
                                                                                         <div className="col-md-3">
                                                                                             <img alt="Store"  src={val.image_url}/>
                                                                                         </div>
                                                                                         <div className="col-md-9">

                                                                                             <div>
                                                                                                 <p style={{fontSize: '12pt'}}>
                                                                                                     {val.text}
                                                                                                 </p>
                                                                                             </div>
                                                                                             {
                                                                                                val.button !== ''
                                                                                                ?
                                                                                                 <div>
                                                                                                     <a className=""
                                                                                                        href={val.link}
                                                                                                        rel="noopener noreferrer"
                                                                                                        target="_blank"
                                                                                                       >
                                                                                                       {val.button}
                                                                                                    </a>
                                                                                                 </div>
                                                                                                :''
                                                                                             }
                                                                                         </div>
                                                                                     </div>
                                                                                     </div>

                                                                                 </Card.Body>
                                                                             </Accordion.Collapse>
                                                                         </Card>
                                                                     ))}
                                                                </Accordion>
                                                            : ''
                                                            }
                                                         </div>
                                                     </div>
                                                </div>
                                              </div>
                                            </div>
                                            : ''
                                        }
                                        {
                                            about_menu && !about_submenu
                                            ?
                                            <div className="wpb_column vc_column_container vc_col-sm-12">
                                                <div className="vc_column-inner">
                                                    <div className="wpb_wrapper">
                                                    { /*<div dangerouslySetInnerHTML={{__html: '<h1>Coming soon</h1>' }} ></div>*/

                                                    }
                                                    { CONFIG.DATA.BACKEND_HOST === "themarketplace" ?
                                                        <div className="row">
                                                            <div className="col-lg-12 aboutus aboutus_desc" style={{ backgroundColor: CONFIG.DATA.LOGO_COLOR }}>
                                                                <div className="wpb_wrapper">
                                                                    <div className="wpb_text_column wpb_content_element ">
                                                                        <div className="wpb_wrapper">
                                                                            <p style={{ fontSize: "14px" }}
                                                                                dangerouslySetInnerHTML={{__html: CONFIG.DATA.ABOUT_US_DESCRIPTION }}
                                                                               >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12" style={{padding: '0px'}}>
                                                                <img loading="lazy" alt="Store" src="/assets/web/images/marketplace_about.png" style={{/* maxHeight: 411, objectFit: 'cover'*/}} className='img-response'/>
                                                            </div>
                                                        </div>
                                                        : 
                                                        <div className="row">
                                                            <div className="col-lg-6" style={{padding: '0px'}}>
                                                                <img loading="lazy" alt="Store" src={CONFIG.DATA.STORE_IMAGE} style={{/* maxHeight: 411, objectFit: 'cover'*/}} className='img-response'/>
                                                            </div>
                                                            <div className="col-lg-6 aboutus aboutus_desc" style={{ backgroundColor: CONFIG.DATA.LOGO_COLOR}} >
                                                                <div className="wpb_wrapper">
                                                                    <div className="wpb_text_column wpb_content_element ">
                                                                        <div className="wpb_wrapper">
                                                                            <p style={{ fontSize: "14px" }}
                                                                                dangerouslySetInnerHTML={{__html: CONFIG.DATA.ABOUT_US_DESCRIPTION }}
                                                                               >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>


{ CONFIG.DATA.BACKEND_HOST === "silverstreet" ?
                                                                                                      
<div className='col-lg-12' style={{height:'550px',position:'relative',marginTop:'60px'}}>
        
        {slides.map((slide, index, array) => {
          return (
            <Slide
              background={slide.background}
              text={slide.text}
              active={index === this.state.activeSlide}
            />
          );
        })}
      <div className="leftArrow" onClick={this.nextSlide.bind(this)}><i className="fa fa-4x fa-arrow-circle-right"></i></div>
      <div className="rightArrow" onClick={this.prevSlide.bind(this)}> <i className="fa fa-4x fa-arrow-circle-left"></i></div>
      
</div>:''
}

                                                            
    </div>


                                                    }
                                                

                                                        { CONFIG.DATA.ABOUT_US_EXTRA_DESC && CONFIG.DATA.ABOUT_US_EXTRA_DESC !== '' ?
                                                        <div className="row">
                                                            <div className="col-lg-12 col-md-12 aboutus_desc_extra">
                                                                <div className="wpb_wrapper">
                                                                    <div className="wpb_text_column wpb_content_element ">
                                                                        <div className="wpb_wrapper">
                                                                            <p style={{ fontSize: "14px" }}
                                                                                dangerouslySetInnerHTML={{__html: CONFIG.DATA.ABOUT_US_EXTRA_DESC }}
                                                                               >
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :''
                                                        }
                                                    </div>
                                                </div>
                                                { CONFIG.DATA.CORPORTATE_COUNTER && CONFIG.DATA.CORPORTATE_COUNTER === true ?
                                                <div className="row-container corporate-counter" style={{marginTop:'50px'}} >
                                                    <div className="wpb_column vc_column_container vc_col-sm-3 vc_col-has-fill">
                                                        <div className="vc_column-inner vc_light_gray" style={{backgroundColor:'#f3f3f3', padding:'50px 0px'}} >
                                                            <div className="wpb_wrapper">
                                                                <div className="organica-counter">
                                                                    <div className="counter-image">
                                                                        <img src="/assets/images/about/about-us-icon1.png" alt="Icon" />
                                                                    </div>
                                                                    <div className="counter-info">
                                                                        <div className="counter-number">
                                                                            <span>30000</span>
                                                                        </div>
                                                                        <div className="counter-text">
                                                                            <span>HAPPY CUSTOMERS</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="wpb_column vc_column_container vc_col-sm-3 vc_col-has-fill">
                                                        <div className="vc_column-inner vc_dark_gray" style={{backgroundColor:'#e8e8e8', padding:'50px 0px'}} >
                                                            <div className="wpb_wrapper">
                                                                <div className="organica-counter">
                                                                    <div className="counter-image">
                                                                        <img src="/assets/images/about/about-us-icon2.png" alt="Icon" />
                                                                    </div>
                                                                    <div className="counter-info">
                                                                        <div className="counter-number"><span>1500</span></div>
                                                                        <div className="counter-text"><span>AWARDS WON</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="wpb_column vc_column_container vc_col-sm-3 vc_col-has-fill">
                                                        <div className="vc_column-inner vc_light_gray" style={{backgroundColor:'#f3f3f3', padding:'50px 0px'}} >
                                                            <div className="wpb_wrapper">
                                                                <div className="organica-counter">
                                                                    <div className="counter-image">
                                                                        <img src="/assets/images/about/about-us-icon3.png" alt="Icon" />
                                                                    </div>
                                                                    <div className="counter-info">
                                                                        <div className="counter-number"><span>75</span></div>
                                                                        <div className="counter-text"><span>YEARS</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="wpb_column vc_column_container vc_col-sm-3 vc_col-has-fill">
                                                        <div className="vc_column-inner vc_dark_gray" style={{backgroundColor:'#e8e8e8', padding:'50px 0px'}} >
                                                            <div className="wpb_wrapper">
                                                                <div className="organica-counter">
                                                                    <div className="counter-image">
                                                                        <img src="/assets/images/about/about-us-icon4.png" alt="Icon" />
                                                                    </div>
                                                                    <div className="counter-info">
                                                                        <div className="counter-number"><span>1000</span></div>
                                                                        <div className="counter-text"><span>COMMUNITY PROJECTS</span></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ''
                                                }
                                            </div>
                                            :''
                                        }

                                        { CONFIG.DATA.TESTIMONIAL && CONFIG.DATA.TESTIMONIAL.length > 0 ?
                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                    <div className="row" style={{paddingTop:'50px'}} >
                                                       <div className="col-md-12 lazy" style={{backgroundColor: '#d9d9d9'}}>
                                                            <Slider {...testimonial_slider_options}>
                                                            {
                                                                CONFIG.DATA.TESTIMONIAL.map((value,index)=>(
                                                                    <div key={index} className="item carousel-item">
                                                                        <p className="testimonial testimonial_slider_optionstext"
                                                                           style={{color: '#000', fontSize: '16px'}}>{value.post}</p>
                                                                        <p style={{color: '#000', fontSize: '16px'}}><b>{value.designation}</b></p>
                                                                        <p className="overview" style={{fontFamily: 'Lobster, cursive',fontSize: 34}}><b>{value.name}</b></p>
                                                                    </div>
                                                                ))
                                                            }
                                                            </Slider>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : '' 
                                        }



                                        { CONFIG.DATA.BRANDS && CONFIG.DATA.BRANDS.length > 0 ?
                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                            <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                    <div className="row" style={{paddingTop:'50px'}} >
                                                       <div className="col-md-12 lazy" style={{backgroundColor: '#fff'}}>
                                                            <Slider {...customer_brand_slider_options}>
                                                            {
                                                                CONFIG.DATA.BRANDS.map((value,index)=>(
                                                                    <div key={index} className="item carousel-item">
                                                                        <img loading="lazy" src={value} alt="brand"/>
                                                                    </div>
                                                                ))
                                                            }
                                                            </Slider>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : '' 
                                        }

                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
    )
    }
}
export default withRouter(About);



